import * as React from 'react'

const SvgCircleIcon = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.16602" y="0.5" width="15" height="15" rx="7.5" fill="white" />
    <rect
      x="1.16602"
      y="0.5"
      width="15"
      height="15"
      rx="7.5"
      stroke="#FF692E"
    />
  </svg>
)

export default SvgCircleIcon
